//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import feedbacks from '../data/feedbacks'
import qs from 'qs'
import types from '../store/mutation-types'

export default {
  name: 'm-notify',
  mounted () {
    // history.pushState(null, null, window.location.href)
    // if (window.addEventListener) {
    //   window.addEventListener('popstate', this.go)
    // } else if (window.attachEvent) {
    //   window.attachEvent('onpopstate', this.go)
    // }
    window.jQuery(window).on('popstate', this.go)
    let orderQuerenURL = '/api/hqdqx/orderQueren/'
    if (this.h5) {
      orderQuerenURL = '/api/channel/hqdqx/orderQueren/'
    }
    this.$http.get(orderQuerenURL + this.$store.state.app.innerCode + '/' + this.$store.state.app.productCode + '/' + this.$store.state.order.unionCode).then(response => {
      this.date = new Date(response.data.orderCreateDate).getFullYear() + '年' + (new Date(response.data.orderCreateDate).getMonth() + 1) + '月' + new Date(response.data.orderCreateDate).getDate() + '日'
      this.holderName = response.data.underwritingInfoList[0].policyHolder.holderName
      this.premium = response.data.underwritingInfoList[0].premium / 100
      this.insurePayWay = response.data.underwritingInfoList[0].insurePayWay
      this.holderPhone = response.data.underwritingInfoList[0].policyHolder.holderPhone
      this.holderAddress = response.data.policyHolderAddress
      // this.contractNumber = response.data.policyInfo
      // this.$store.commit('updateOrderName', response.data.busProductRelation.productName)
      // this.$store.commit('updateOrderCompany', response.data.busProductRelation.suppliername)
      // this.$store.commit('updateOrderNumber', response.data.busOrder.orderCode)
      // this.$store.commit('updateInsuredName', response.data.underwritingInfoList[0].policyInsured.insuredName)
      // this.$store.commit('updateInsuredIDNumber', response.data.underwritingInfoList[0].policyInsured.insuredIdNumber)
      // this.$store.commit('updateOrderInsuranceAmount', response.data.underwritingInfoList[0].coverageMultiples / 100 + '')
      // this.$store.commit('updateOrderPaymentPeriod', response.data.underwritingInfoList[0].insurePayWay + '')
      // this.$store.commit('updateOrderInsurancePeriod', response.data.underwritingInfoList[0].durationPeriodValue + '')
      // this.$store.commit('updateHolderPhoneNumber', response.data.underwritingInfoList[0].policyHolder.holderPhone)
      // this.$store.commit('updatePaymentByIDNumber', response.data.underwritingInfoList[0].premium / response.data.underwritingInfoList[0].coverageMultiples)
    })
    document.title = '回访确认'
  },
  destroyed () {
    // if (window.removeEventListener) {
    //   window.removeEventListener('popstate', this.go)
    // } else if (window.detachEvent) {
    //   window.detachEvent('onpopstate', this.go)
    // }
    window.jQuery(window).off('popstate', this.go)
  },
  data () {
    return {
      // notifies: feedbacks,
      // contractNumber: null,
      positivePicValue: null,
      negativePicValue: null,
      positivePicSrc: '',
      negativePicSrc: '',
      date: '',
      holderName: '',
      premium: 0,
      insurePayWay: 0,
      holderPhone: '',
      holderAddress: '',
      currentProductIndexURL: '',
      commonResultURL: ''
    }
  },
  created () {
    this.currentProductIndexURL = window.location.pathname + '#/' + this.$store.state.app.innerCode + '/' + this.$store.state.app.productCode + '?' + qs.stringify(this.$route.query)
    this.commonResultURL = '/products/' + this.$store.state.app.productCode + '/result?' + (this.h5 ? 'merchantCode' : 'innerCode') + '=' + this.$store.state.app.innerCode + '&unionCode=' + this.$store.state.order.unionCode + '&indexURL=' + encodeURIComponent(this.currentProductIndexURL)
  },
  computed: {
    h5 () {
      return this.$store.state.app.h5
    },
    confirmFeedback () {
      return this.$store.state.order.confirmFeedback
    },
    needIDCard () {
      if (this.$store.state.app.productCode === '150634119420883220' || this.$store.state.app.productCode === '150631164164706555') {
        return false
      }
      if (!this.$store.state.config.feedback) return
      if (this.premium * this.insurePayWay > this.$store.state.config.feedback.sum) {
        return true
      }
      // if (process.env.NODE_ENV === 'development') return true
      return false
    },
    hq () {
      if (this.$store.state.app.productCode === '150634119420883220' || this.$store.state.app.productCode === '150631164164706555') {
        return true
      }
    }
  },
  methods: {
    go (event) {
      // window.history.pushState('forward', null, '#')
      window.history.forward(1)
      // history.go(1)
    },
    changeFeedback (value) {
      this.$store.commit(types.UPDATE_ORDER_CONFIRMFEEDBACK, value)
    },
    compressImg (dataURI, callback) {
      var canvas = document.createElement('canvas')
      var ctx = canvas.getContext('2d')
      var image = new Image()
      image.onload = function () {
        var cw = image.width
        var ch = image.height
        var w = image.width
        var h = image.height
        canvas.width = w
        canvas.height = h
        if (cw > 200 && cw > ch) {
          w = 200
          h = (200 * ch) / cw
          canvas.width = w
          canvas.height = h
        }
        if (ch > 200 && ch > cw) {
          h = 200
          w = (200 * cw) / ch
          canvas.width = w
          canvas.height = h
        }
        ctx.drawImage(image, 0, 0, w, h)
        callback(canvas.toDataURL('image/jpeg', 0.7))
      }
      image.src = dataURI
    },
    next () {
      if (!this.needIDCard) {
        this.$vux.loading.show({
          text: '正在提交'
        })
        this.$http.post((this.h5 ? '/api/channel/hqdqx/visitFlag/' : '/api/hqdqx/visitFlag/') + this.$store.state.app.innerCode + '/' + this.$store.state.app.productCode + '/' + this.$store.state.order.unionCode, qs.stringify({visitFlag: this.confirmFeedback ? 1 : 0})).then(response => {
          this.$vux.loading.hide()
          if (response.data !== 'success') {
            this.$vux.toast.show({
              type: 'text',
              text: '客官，回访信息提交失败',
              position: 'top',
              width: '20em'
            })
            return
          }
          window.location.href = this.commonResultURL
        })
        return
      }
      if (this.positivePicValue === null) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请上传身份证正面照片',
          position: 'top',
          width: '20em'
        })
        return
      }
      if (this.positivePicValue.size >= 3 * 1024 * 1024) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，照片不能超过3M',
          position: 'top',
          width: '20em'
        })
        return
      }
      if (this.negativePicValue === null) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请上传身份证反面照片',
          position: 'top',
          width: '20em'
        })
        return
      }
      if (this.negativePicValue.size >= 3 * 1024 * 1024) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，照片不能超过3M',
          position: 'top',
          width: '20em'
        })
        return
      }
      const data = {
        visitFlag: this.confirmFeedback ? 1 : 0,
        holderIdCardPositive: '',
        holderIdCardOpposite: ''
      }
      const reader1 = new FileReader()
      const reader2 = new FileReader()
      const that = this
      reader1.addEventListener('load', (event) => {
        that.compressImg(event.target.result, (compressedImg) => {
          that.positivePicSrc = event.target.result
          data.holderIdCardPositive = compressedImg.split(',')[1]
          ready(that, data)
        })
      }, false)
      reader2.addEventListener('load', function (event) {
        that.compressImg(event.target.result, (compressedImg) => {
          that.negativePicSrc = event.target.result
          data.holderIdCardOpposite = compressedImg.split(',')[1]
          ready(that, data)
        })
      }, false)
      reader1.readAsDataURL(this.positivePicValue)
      reader2.readAsDataURL(this.negativePicValue)

      function ready (that, data) {
        if (data.holderIdCardPositive !== '' && data.holderIdCardOpposite !== '') {
          that.$vux.loading.show({
            text: '正在提交'
          })
          that.$http.post((this.h5 ? '/api/channel/hqdqx/visitFlag/' : '/api/hqdqx/visitFlag/') + that.$store.state.app.innerCode + '/' + that.$store.state.app.productCode + '/' + that.$store.state.order.unionCode, qs.stringify(data))
          .then(response => {
            that.$vux.loading.hide()
            if (response.data !== 'success') {
              that.$vux.toast.show({
                type: 'text',
                text: '客官，身份证提交失败',
                position: 'top',
                width: '20em'
              })
              return
            }
            window.location.href = that.commonResultURL
          })
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Feedback.vue